"use strict";
'use es6'; // Prevent unwanted focus styles

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("../listeners/focusStylesListener");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _useUniqueId = _interopRequireDefault(require("react-utils/hooks/useUniqueId"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _FieldsetContext = require("../context/FieldsetContext");

var _Checkable = _interopRequireDefault(require("../decorators/Checkable"));

var _UICheckmark = _interopRequireDefault(require("../icon/icons/UICheckmark"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _TabIndex = require("../utils/TabIndex");

var _CheckboxConstants = require("./CheckboxConstants");

var _ToggleInputWrapper = _interopRequireDefault(require("./internal/ToggleInputWrapper"));

var renderCheckmark = (0, _memoize.default)(function () {
  return _react.default.createElement(_UICheckmark.default, {
    className: "private-checkbox__icon__inner"
  });
});
var renderDash = (0, _memoize.default)(function () {
  return _react.default.createElement("svg", {
    role: "presentation",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    className: "private-checkbox__icon__inner",
    d: "M 2 6 L12 6 L12 9 L2 9 L2 6 z"
  }));
});
var renderIndicator = (0, _memoize.default)(function (color) {
  return _react.default.createElement("span", {
    className: "private-checkbox__indicator",
    "data-indicator": true,
    style: {
      color: color
    }
  }, _react.default.createElement("span", {
    className: "private-checkbox__icon private-checkbox__check"
  }, renderCheckmark()), _react.default.createElement("span", {
    className: "private-checkbox__icon private-checkbox__dash"
  }, renderDash()));
});
var UICheckbox = (0, _react.forwardRef)(function (props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      checked = props.checked,
      children = props.children,
      className = props.className,
      color = props.color,
      description = props.description,
      disabled = props.disabled,
      id = props.id,
      indeterminate = props.indeterminate,
      innerPadding = props.innerPadding,
      name = props.name,
      _onChange = props.onChange,
      readOnly = props.readOnly,
      size = props.size,
      tabIndex = props.tabIndex,
      value = props.value,
      rest = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "checked", "children", "className", "color", "description", "disabled", "id", "indeterminate", "innerPadding", "name", "onChange", "readOnly", "size", "tabIndex", "value"]);

  var _useContext = (0, _react.useContext)(_FieldsetContext.FieldsetContext),
      fieldSize = _useContext.size,
      fieldDisabled = _useContext.disabled;

  if (process.env.NODE_ENV !== 'production') {
    if (children == null && !ariaLabel && !ariaLabelledBy) {
      _devLogger.default.warn({
        message: "UICheckbox: `aria-label` or `aria-labelledby` is required if you don't define `children`.",
        key: 'UICheckbox: no label'
      });
    }

    if (ariaLabel && (children || ariaLabelledBy)) {
      _devLogger.default.warn({
        message: 'UICheckbox: `aria-label` should not be used with `children` or `aria-labelledby`.',
        key: 'UICheckbox: aria-label hides children',
        url: 'https://git.hubteam.com/HubSpot/UIComponents/pull/8473/files#r1011220'
      });
    }
  }

  var descriptionId = (0, _useUniqueId.default)('checkbox-');
  var childWrapperId = (0, _useUniqueId.default)('checkbox-content-');
  var computedDisabled = disabled || fieldDisabled;
  var computedSize = size || fieldSize;
  var ariaLabelledByIds = (0, _classnames.default)(ariaLabelledBy, children && childWrapperId);
  return _react.default.createElement(_ToggleInputWrapper.default, Object.assign({}, rest, {
    checked: checked,
    childWrapperId: childWrapperId,
    className: (0, _classnames.default)(className, 'private-checkbox', _CheckboxConstants.PADDING_OPTIONS[innerPadding], children == null && 'private-checkbox--unlabeled'),
    description: description,
    descriptionId: descriptionId,
    disabled: computedDisabled,
    input: _react.default.createElement("input", {
      "aria-describedby": description ? descriptionId : null,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledByIds,
      checked: checked,
      className: 'private-checkbox__input sr-only' + (indeterminate ? " indeterminate" : ""),
      disabled: computedDisabled,
      id: id,
      name: name,
      onChange: function onChange(evt) {
        if (disabled || readOnly) {
          evt.preventDefault();
          return;
        }

        _onChange(evt);
      },
      readOnly: readOnly,
      tabIndex: (0, _TabIndex.getTabIndex)(readOnly || disabled, tabIndex),
      type: "checkbox",
      value: value
    }),
    indicator: renderIndicator(color),
    onChange: _onChange,
    readOnly: readOnly,
    ref: ref,
    size: computedSize
  }), children);
});
UICheckbox.propTypes = {
  alignment: _propTypes.default.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
  'aria-label': _propTypes.default.string,
  'aria-labelledby': _propTypes.default.string,
  checked: _propTypes.default.bool,
  children: _propTypes.default.node,
  color: _propTypes.default.string,
  description: _propTypes.default.node,
  descriptionLayout: _propTypes.default.oneOf(['horizontal', 'vertical']),
  disabled: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  innerPadding: _propTypes.default.oneOf(Object.keys(_CheckboxConstants.PADDING_OPTIONS)).isRequired,
  labelClassName: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _propTypes.default.oneOf(['default'])]),
  value: _propTypes.default.any
};
UICheckbox.defaultProps = {
  alignment: 'start',
  checked: false,
  descriptionLayout: 'vertical',
  innerPadding: 'default'
};
UICheckbox.displayName = 'UICheckbox';

var _default = (0, _Checkable.default)(UICheckbox);

exports.default = _default;
module.exports = exports.default;